export const WEDDING_DRESS_OPTIONS = {
  silhouette: ['A-Line', 'Ball Gown', 'Mermaid', 'Trumpet', 'Sheath', 'Empire', 'Fit and Flare', 'Column', 'Tea-Length', 'High-Low', 'Mini', 'Other'],
  neckline: ['Sweetheart', 'V-Neck', 'Strapless', 'Off-Shoulder', 'Illusion', 'Halter', 'Square', 'Scoop', 'Boat', 'Queen Anne', 'High Neck', 'Asymmetric', 'Other'],
  sleeves: ['Sleeveless', 'Cap Sleeves', 'Short Sleeves', '3/4 Sleeves', 'Long Sleeves', 'Puff Sleeves', 'Off-Shoulder Sleeves', 'Illusion Sleeves', 'One Shoulder', 'Detachable Sleeves', 'Other'],
  back_design: ['Open Back', 'Low Back', 'High Back', 'Keyhole Back', 'Illusion Back', 'Corset Lace-Up', 'Buttoned Back', 'Zip Back', 'Sheer Back', 'Other'],
  train: ['None', 'Sweep', 'Court', 'Chapel', 'Cathedral', 'Royal', 'Detachable', 'Other'],
  vibe: ['Classic', 'Modern', 'Boho', 'Minimal', 'Vintage', 'Royal', 'Sexy', 'Romantic', 'Glamorous', 'Other'],
  main_fabric: ['Satin', 'Mikado', 'Tulle', 'Chiffon', 'Lace', 'Organza', 'Crepe', 'Silk', 'Georgette', 'Mesh', 'Other'],
  lining: ['Fully lined', 'Partially lined', 'Unlined', 'Unknown'],
  embellishments: ['Beading', 'Embroidery', 'Sequins', 'Pearls', 'Crystals', 'Applique', 'None', 'Other'],
  fabric_color: ['Pure white', 'Ivory', 'Off-white', 'Champagne', 'Custom'],
  size_label: ['XS', 'S', 'M', 'L', 'Custom', 'Unknown'],
  adjustability: ['Corset', 'Stretch fabric', 'Altered', 'Not adjustable'],
  weight_class: ['Light', 'Medium', 'Heavy'],
  mobility: ['Yes', 'Somewhat', 'No'],
  danceable: ['Yes', 'No'],
  deposit_required: ['Yes', 'No'],
  cleaning_policy: ['Seller cleaned before handoff', 'Buyer handles cleaning', 'Professional cleaning required', 'Included in price', 'Other'],
  try_on: ['Yes', 'No'],
  delivery: ['Pickup only', 'Courier delivery', 'Pickup or courier', 'Meet-up', 'Other'],
  accessories: ['Veil', 'Gloves', 'Belt', 'None'],
};

const DRESS_COLOR_OPTIONS_BY_SUBCATEGORY = {
  'Wedding Dresses': ['Pure white', 'Ivory', 'Off-white', 'Champagne', 'Custom'],
  'Engagement Dresses': [
    'Pure white',
    'Ivory',
    'Off-white',
    'Champagne',
    'Blush Pink',
    'Rose',
    'Dusty Rose',
    'Mauve',
    'Nude',
    'Lilac',
    'Sage Green',
    'Sky Blue',
    'Red',
    'Burgundy',
    'Emerald',
    'Navy',
    'Black',
    'Gold',
    'Silver',
    'Custom',
  ],
  'Soiree Dresses': [
    'Black',
    'Navy',
    'Royal Blue',
    'Emerald',
    'Burgundy',
    'Red',
    'Purple',
    'Fuchsia',
    'Rose Gold',
    'Gold',
    'Silver',
    'Champagne',
    'Nude',
    'Blush Pink',
    'White',
    'Ivory',
    'Custom',
  ],
};

export const getWeddingDressColorOptions = (subcategory) =>
  DRESS_COLOR_OPTIONS_BY_SUBCATEGORY[subcategory] || WEDDING_DRESS_OPTIONS.fabric_color;

export const EMPTY_WEDDING_DRESS_FORM = {
  silhouette: '',
  neckline: '',
  sleeves: '',
  back_design: '',
  train: '',
  vibe: '',
  main_fabric: '',
  lining: '',
  embellishments: [],
  fabric_color: '',
  bust_cm: '',
  waist_cm: '',
  hips_cm: '',
  worn_height_cm: '',
  weight_range_kg: '',
  size_label: '',
  adjustability: '',
  weight_class: '',
  mobility: '',
  danceable: '',
  flaws: '',
  sale_price: '',
  deposit_required: '',
  deposit_amount: '',
  cleaning_policy: '',
  try_on: '',
  delivery: '',
  extras: [],
};

const norm = (value) => String(value || '').trim().toLowerCase();

export const normalizeToOption = (value, options) => {
  if (!value) return '';
  const normalized = norm(value);
  const exact = options.find((opt) => norm(opt) === normalized);
  if (exact) return exact;
  const includes = options.find((opt) => normalized.includes(norm(opt)) || norm(opt).includes(normalized));
  return includes || value;
};

export const buildWeddingDressJson = ({ formData, dressData, imageNames, colorOptions }) => ({
  title: formData.title || '',
  occasion: formData.subcategory || 'Wedding Dresses',
  condition: formData.condition || '',
  availability: formData.in_stock || '1',
  style: {
    silhouette: normalizeToOption(dressData.silhouette, WEDDING_DRESS_OPTIONS.silhouette),
    neckline: normalizeToOption(dressData.neckline, WEDDING_DRESS_OPTIONS.neckline),
    sleeves: normalizeToOption(dressData.sleeves, WEDDING_DRESS_OPTIONS.sleeves),
    back: normalizeToOption(dressData.back_design, WEDDING_DRESS_OPTIONS.back_design),
    train: normalizeToOption(dressData.train, WEDDING_DRESS_OPTIONS.train),
    vibe: normalizeToOption(dressData.vibe, WEDDING_DRESS_OPTIONS.vibe),
  },
  fabric: {
    main: normalizeToOption(dressData.main_fabric, WEDDING_DRESS_OPTIONS.main_fabric),
    lining: normalizeToOption(dressData.lining, WEDDING_DRESS_OPTIONS.lining),
    embellishments: (dressData.embellishments || []).map((e) => normalizeToOption(e, WEDDING_DRESS_OPTIONS.embellishments)),
    color: normalizeToOption(
      dressData.fabric_color,
      colorOptions || getWeddingDressColorOptions(formData.subcategory),
    ),
  },
  measurements: {
    bust: dressData.bust_cm || '',
    waist: dressData.waist_cm || '',
    hips: dressData.hips_cm || '',
    height: dressData.worn_height_cm || '',
    weight_range: dressData.weight_range_kg || '',
    size: normalizeToOption(dressData.size_label, WEDDING_DRESS_OPTIONS.size_label),
    adjustability: normalizeToOption(dressData.adjustability, WEDDING_DRESS_OPTIONS.adjustability),
  },
  comfort: {
    weight: normalizeToOption(dressData.weight_class, WEDDING_DRESS_OPTIONS.weight_class),
    mobility: normalizeToOption(dressData.mobility, WEDDING_DRESS_OPTIONS.mobility),
    danceable: normalizeToOption(dressData.danceable, WEDDING_DRESS_OPTIONS.danceable),
    flaws: dressData.flaws || '',
  },
  pricing: {
    rental_price: '',
    sale_price: dressData.sale_price || '',
    deposit: dressData.deposit_required === 'Yes' ? (dressData.deposit_amount || '') : 'No',
    cleaning_policy: normalizeToOption(dressData.cleaning_policy, WEDDING_DRESS_OPTIONS.cleaning_policy),
  },
  logistics: {
    try_on: normalizeToOption(dressData.try_on, WEDDING_DRESS_OPTIONS.try_on),
    delivery: normalizeToOption(dressData.delivery, WEDDING_DRESS_OPTIONS.delivery),
  },
  extras: (dressData.extras || []).map((e) => normalizeToOption(e, WEDDING_DRESS_OPTIONS.accessories)),
  photos: imageNames || [],
});
